import { render, staticRenderFns } from "./BasicFileUpload.vue?vue&type=template&id=961ce046&scoped=true&v-if=todisplay&"
import script from "./BasicFileUpload.vue?vue&type=script&lang=js&"
export * from "./BasicFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./BasicFileUpload.vue?vue&type=style&index=0&id=961ce046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ce046",
  null
  
)

export default component.exports